module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAGCAYAAADQQP5pAAAAAXNSR0IArs4c6QAAALlJREFUKFPFkr0OQUEUhL9JdCQiUdJo1H5exk9JycNoKV1e5qLWqJQ3QaKUHDnJFrI2CpHYcs7szO6cEYCZ1YEB8AA2km6Op46Z1YBRmGWSLh+4VWAIlICtpELBbA80w8Uj0Jd0j4XMzAWc2wqzE9BNPdDMysAOaAfuGei44QxYROJjSVnCcAIsI3wqaZXgegrrCJ//xdD3dwAaX0bak3RN/LAC5G+RvpTGl+ul8SL8sjQerZfGy1g8AcZlXv0vsfMjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img32.png
// module id = G21r
// module chunks = 1